import React from "react";
import styles from "./Social.module.scss";
import SectionTitle from "../SectionTitle/SectionTitle";
import { GlowingIcon } from "../../UI/GlowingIcon";

interface Props {
    headerTitle: {
        text: string;
        gradientText: string;
        underlineText?: string;
    };
    headerText: string;
    bodyTitle: string;
    bodyText: string;
    iconName: string;
    color: "magenta" | "blue";
    link?: {
        src: string;
        text: string;
    };
}

const SocialItem: React.FC<Props> = ({ headerTitle, headerText, bodyTitle, bodyText, iconName, color, link }) => {
    const paragraphs = bodyText.split(".");

    return (
        <div className={[styles.item, styles[color]].join(" ")}>
            <div className={styles.itemHeader}>
                <SectionTitle
                    text={headerTitle.text}
                    gradientText={headerTitle.gradientText}
                    underlineText={headerTitle.underlineText}
                    small={true}
                    className={styles.itemTitle}
                />
                <p className="p2">{headerText}</p>
                {link && (
                    <a className="p1" href={link.src} target="_blank" rel="noreferrer">
                        {link.text}
                    </a>
                )}
                <div className={styles.star}></div>
                <GlowingIcon name={iconName} color={color} className={styles.icon} />
            </div>
            <div className={styles.itemBody}>
                <GlowingIcon name={iconName} color={color} className={styles.icon} />
                <div className={styles.itemBodyText}>
                    <p className={styles.itemBodyTitle}>{bodyTitle}</p>
                    {paragraphs.map((p) => (
                        <p key={p}>{p}</p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SocialItem;
